import {addGlobalEventListener, qsa, qs, updateURLparams} from "./helpers";

const SELECT_BOX_QS = ".custom-select"

function handleSelectedHTML(box) {
  const isMultiselect = box.matches("[data-multiselect]")
  const inputs = qsa(".option input", box)
  const selected = qs(".selected", box)

  let selectedItems = inputs
    .map((input) => {
      let checkedInput = input.checked || input.matches(".active")

      if (!checkedInput) return null

      if (isMultiselect) {
        return `
          <div class="js-selected-item" data-value="${input.value}">
            <span>${input.dataset.label}</span>
            <button class="js-remove-selected-item">
            remove
            </button>
          </div>`
      }

      return input.dataset.label
    }).join("");

  selected.innerHTML = selectedItems.length > 0 ? selectedItems : selected.dataset.placeholder
}

function showSelected(e) {

  if (!e.target) {
    qsa(SELECT_BOX_QS).forEach((selectBox) => handleSelectedHTML(selectBox))
    return
  }

  if(e.target.dataset.email) updateURLparams({email: e.target.dataset.email})

  handleSelectedHTML(e.target.closest(SELECT_BOX_QS))
}

function closeOtherBoxes(target = false, closeParent = true) {
  qsa(SELECT_BOX_QS).forEach((box) => {
    const checkParent = closeParent ? false : box.matches(".parent.openned")
    if (box !== target && !checkParent) box.classList.remove("openned")
  });
}

function handleSelectedLabels({target}) {
  const currentBox = target.closest(SELECT_BOX_QS)
  const currentItem = target.closest(".js-selected-item")
  const currentValue = currentItem.dataset.value

  qsa('input[type="checkbox"]', currentBox).forEach((checkbox) => {
    if (checkbox.value === currentValue) {
      checkbox.checked = false
      currentItem.remove()
      showSelected(checkbox)
    }
  });
}

function toggleSelect({target}) {
  const isOption = target.matches(".option")
  const isSelect = target.matches(SELECT_BOX_QS)
  const isRemoveSelected = target.matches(".js-remove-selected-item")

  if (isOption || target.type === "checkbox" || isRemoveSelected) return;

  if (isSelect || target.type === "radio") {
    /* close other boxes except the parent one */
    const closeTarget = isOption ? target.closest(SELECT_BOX_QS) : target
    closeOtherBoxes(closeTarget, false)

    /* toggle current one */
    target.classList.toggle("openned")
    return;
  }

  closeOtherBoxes()
}

export function initCustomSelect() {
  document.addEventListener("click", toggleSelect)
  addGlobalEventListener("click", ".js-remove-selected-item", handleSelectedLabels);
  addGlobalEventListener("change", `${SELECT_BOX_QS} .option input`, showSelected);
}
